import { PRICE_LIST } from "src/config/priceTypeList";
import { getProductInfo } from "src/utils/storage/product";
import SiteTypeOptions from "../Common/SiteTypeOptions";
import { getLanguage } from "src/utils/localization";
import { useTranslation } from "react-i18next";

interface ISiteTrialUIProps {
  userName: any;
  telNumber: any;
  companyName: any;
  purpose: any;
  confirmPolicy: any;
  handleChange: any;
  isCheckTrial: any;
  tiralApply: any;
  showType: any;
  goBack: any;
  makeSite: any;

  openTermsService: any;
  openPrivatePolicy: any;
  openPaidTermsService?: any;
  usernameNoti: any;
  contactInfoNoti: any;
  companyNoti: any;
  purposeNoti: any;
  // showPolicy: any;
  // tabTarget: any;
  // showSiteNewModal: any;
  // hideModal: any;
  // type: any;
  // code: any;
}
const SiteTrialUI = ({
  userName,
  telNumber,
  companyName,
  purpose,
  confirmPolicy,
  handleChange,
  isCheckTrial,
  tiralApply,
  showType,
  goBack,
  makeSite,
  openTermsService,
  openPrivatePolicy,
  openPaidTermsService,
  usernameNoti,
  contactInfoNoti,
  companyNoti,
  purposeNoti,
}: // showSiteNewModal,
// hideModal,
// type,
// code,
// showPolicy,
// tabTarget,
ISiteTrialUIProps) => {
  const { t } = useTranslation();
  const productInfo =
    PRICE_LIST({ t })[getProductInfo().key].filter(
      (item: any) => item.key === "free"
    ).length > 0
      ? PRICE_LIST({ t })[getProductInfo().key].filter(
          (item: any) => item.key === "free"
        )[0]
      : { key: "", name: "", featuresCnt: 0, upcCnt: -1 };
  const productName = getProductInfo().name;
  const productKey = getProductInfo().key;
  const lang = getLanguage();
  return (
    <div className="containerBox" style={{ marginTop: 120 }}>
      <div className="container">
        {showType === "POSSIBLE" ? (
          <div className="site">
            <h3 className="site__title">
              {t("siteType.free.title", productName)}
            </h3>
            <p className="site__desc">{t("siteType.free.subTitle")}</p>
            <div className="flex justify-space-between">
              <div className="flex-item box box__lt bg-white">
                <form className="form">
                  <h4 className="form-title">
                    {t("siteType.free.detail.title")}
                  </h4>
                  <div className="form-item">
                    <span className="form-item-title">
                      {t("siteType.free.detail.username")}
                      <span className="text text--green">&nbsp;*</span>
                    </span>
                    <input
                      type="text"
                      id="userName"
                      name="userName"
                      title={t("siteType.free.detail.username")}
                      value={userName}
                      onChange={handleChange}
                      maxLength={60}
                      className={
                        usernameNoti !== ""
                          ? "form-control form-textbox-invalid custom-form mg mb-20"
                          : "form-control custom-form"
                      }
                    />
                  </div>

                  {usernameNoti !== "" ? (
                    <div className="mg mt--10 mb-20">
                      <span className="form-invalid">{usernameNoti}</span>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="form-item">
                    <span className="form-item-title">
                      {t("siteType.free.detail.phoneNumber")}
                      <span className="text text--green">&nbsp;*</span>
                    </span>
                    <input
                      type="text"
                      id="telNumber"
                      name="telNumber"
                      title={t("siteType.free.detail.phoneNumber")}
                      value={telNumber}
                      onChange={handleChange}
                      maxLength={60}
                      className={
                        contactInfoNoti !== ""
                          ? "form-control form-textbox-invalid custom-form mg mb-20"
                          : "form-control custom-form"
                      }
                    />
                  </div>

                  {contactInfoNoti !== "" ? (
                    <div className="mg mt--10 mb-20">
                      <span className="form-invalid">{contactInfoNoti}</span>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="form-item">
                    <span className="form-item-title">
                      {t("siteType.free.detail.company")}
                      <span className="text text--green">&nbsp;*</span>
                    </span>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      title={t("siteType.free.detail.company")}
                      value={companyName}
                      onChange={handleChange}
                      maxLength={256}
                      className={
                        companyNoti !== ""
                          ? "form-control form-textbox-invalid custom-form mg mb-20"
                          : "form-control custom-form"
                      }
                    />
                  </div>

                  {companyNoti !== "" ? (
                    <div className="mg mt--10 mb-20">
                      <span className="form-invalid">{companyNoti}</span>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="form-item">
                    <span className="form-item-title">
                      {t("siteType.free.detail.purpose")}
                      <span className="text text--green">&nbsp;*</span>
                    </span>
                    <textarea
                      id="purpose"
                      name="purpose"
                      title={t("siteType.free.detail.purpose")}
                      value={purpose}
                      onChange={handleChange}
                      maxLength={500}
                      className={
                        purposeNoti !== ""
                          ? "form-control form-textarea form-textarea-invalid custom-form mg mb-20"
                          : "form-control custom-form form-textarea"
                      }
                    />
                  </div>

                  {purposeNoti !== "" ? (
                    <div className="mg mt--10 mb-20">
                      <span className="form-invalid">{purposeNoti}</span>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="form-item">
                    <div className="flex flex-wrap">
                      <input
                        type="checkbox"
                        name="confirmPolicy"
                        id="confirmPolicy"
                        checked={confirmPolicy}
                        onChange={handleChange}
                        // htmlFor="confirmPolicy"
                      />
                      <label
                        className="inputArea-label"
                        htmlFor="confirmPolicy"
                      ></label>
                      <label
                        className={`form-input-label ${
                          lang === "ko" ? "" : "mg ml-24"
                        }`}
                      >
                        {t("siteType.agreement1")}
                        <a onClick={openTermsService}>
                          <b className="text text--black">
                            {t("siteType.agreement2")}
                          </b>
                        </a>
                        {/* {t("siteType.agreement3")}
                      <a onClick={openPaidTermsService}>
                        <b className="text text--black">
                          {t("siteType.agreement4")}
                        </b>
                      </a> */}
                        {t("siteType.agreement5")}
                        <a onClick={openPrivatePolicy}>
                          <b className="text text--black">
                            {t("siteType.agreement6")}
                          </b>
                        </a>
                        {t("siteType.agreement7")}
                      </label>
                    </div>
                    <div className="mg mt-20 form-item-delete">
                      {t("siteType.free.detail.info")}
                    </div>
                  </div>
                </form>
              </div>

              <div className="flex-item box box__rt bg-white">
                <form>
                  <SiteTypeOptions
                    productKey={productKey}
                    // priceType={"trial"}
                    // handleChange={handleChange}
                  />
                  {/* <h4 className="form-title">
                  {t("siteType.free.orderSpecification.title")}
                </h4>
                <div className="form-item">
                  <span className="form-item-title">
                    {t(
                      "siteType.free.orderSpecification.planType"
                    )}
                  </span>
                  <select
                    name="siteType"
                    value="trial"
                    onChange={handleChange}
                    className="form-control custom-form width w-370"
                  >
                    <option value="trial" disabled={!confirmTrial}>
                      {t(
                        "siteType.subscriptionType." +
                          productKey +
                          ".subscriptionType_free"
                      )}
                    </option>
                    <option value="basic" disabled={!confirmBasic}>
                      {t(
                        "siteType.subscriptionType." +
                          productKey +
                          ".subscriptionType_basic"
                      )}
                    </option>
                    {productKey === "wrapsody" && (
                      <option value="basicPlus" disabled={!confirmBasicPlus}>
                        {t(
                          "siteType.subscriptionType." +
                            productKey +
                            ".subscriptionType_basicPlus"
                        )}
                      </option>
                    )}
                    <option value="plus" disabled={!confirmPlus}>
                      {t(
                        "siteType.subscriptionType." +
                          productKey +
                          ".subscriptionType_plus"
                      )}
                    </option>

                    {productKey === "wrapsody" && (
                      <option value="plusPlus" disabled={!confirmPlusPlus}>
                        {t(
                          "siteType.subscriptionType." +
                            productKey +
                            ".subscriptionType_plusPlus"
                        )}
                      </option>
                    )}
                    <option value="promotion" disabled={!confirmPromotion}>
                      {t(
                        "siteType.subscriptionType." +
                          productKey +
                          ".subscriptionType_premium"
                      )}
                    </option>
                  </select>
                </div> */}
                  {Array.from(Array(productInfo.featuresCnt).keys()).map(
                    (item, index1) => (
                      <div className="text text--lg mg mb-16">
                        <i className="icon_check_info inline-block vertical-middle" />
                        <span className="terms inline-block vertical-middle mg ml-10 text text--14">
                          {t(
                            "subscriptionType.terms." +
                              productKey +
                              ".free_" +
                              (index1 + 1)
                          )}
                        </span>
                      </div>
                    )
                  )}

                  <button
                    type="button"
                    disabled={!isCheckTrial}
                    onClick={tiralApply}
                    className="btn btn-green width w-100p mg mt-20 pd py-10"
                  >
                    {t("siteType.free.orderSpecification.startBtn")}
                  </button>
                </form>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {showType === "APPLY" ? (
          <div className="site">
            <h3 className="site__title">{t("siteType.complete.title")}</h3>
            <p className="site__desc">{t("siteType.complete.subTitle")}</p>
            <div className="trialApply">
              <div className="image" />
            </div>
            <div className="applyButton">
              <button type="button" onClick={goBack} className="btn btn-green">
                {t("siteType.complete.goToMainBtn")}
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        {showType === "T_APPLY" ? (
          <div className="site">
            <h3 className="site__title">
              {t("siteManagement.free.beforeApplication.title")}
            </h3>
            <p className="site__desc">
              {t("siteManagement.free.beforeApplication.subTitle")}
            </p>
            <div className="trialApply">
              <div className="image" />
            </div>
            <div className="applyButton">
              <button type="button" onClick={goBack} className="btn btn-green">
                {t("siteManagement.free.beforeApplication.goToMainBtn")}
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        {showType === "T_APPROVED" ? (
          <div className="site">
            <h3 className="site__title">
              {t("siteManagement.free.afterApplication.title")}
            </h3>
            <p className="site__desc">
              {t("siteManagement.free.afterApplication.subTitle")}
            </p>
            <div className="trialApply">
              <div className="image" />
            </div>
            <div className="applyButton">
              <button
                type="button"
                onClick={makeSite}
                className="btn btn-green"
              >
                {t("siteManagement.free.afterApplication.goToMainBtn")}
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        {/* {showSiteNewModal && (
        <SiteNewModal
          showSiteNewModal={showSiteNewModal}
          hideModal={hideModal}
          type={type}
          code={code}
        />
      )}
      {showPolicy && (
        <PolicyModal
          showPolicy={showPolicy}
          hideModal={hideModal}
          tabTarget={tabTarget}
          openTermsService={openTermsService}
          openPrivatePolicy={openPrivatePolicy}
          openPaidTermsService={openPaidTermsService}
        />
      )} */}
      </div>
    </div>
  );
};

export default SiteTrialUI;
